import type { AutocompleteOption } from '../../../types';

export const DEFAULT_OPTION: AutocompleteOption = {
    id: 'default',
    text: 'Hvor som helst',
    type: 'Default',
};
